import { reduce } from "lodash";
import Configurator from "../../config/Configurator";

const ENDPOINT_PATH = "/api/v2/io/records/abstract/transmitter_exposed";

/**
 * Queries each redundant transmitter address in order and returns the
 * `latestRecord` from the first one that responds successfully.
 * @returns {Promise<Object|null>} IO state record, or null if all fail
 */
export default async function fetchTransmitterRedundancySwitch() {
  const {
    TRANSMITTER_REDUNDANCY_SWITCH_TAGS: tags = [],
    TRANSMITTER_REDUNDANCY_SWITCH_ADDRESSES: addresses = [],
  } = (await Configurator()) ?? {};

  if (!tags.length || !addresses.length) return null;

  const query = tags
    .map(function (tag) {
      return `tag=${tag}`;
    })
    .join("&");

  return reduce(
    addresses,
    async function (chain, addr) {
      const previous = await chain;

      if (previous) return previous;

      try {
        const res = await fetch(`${addr}${ENDPOINT_PATH}?${query}`);

        if (!res.ok) return null;

        const data = await res.json();

        return data?.data?.latestRecord ?? null;
      } catch {
        return null;
      }
    },
    Promise.resolve(null),
  );
}
